import './../vignette.style.scss';
import './table.style.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { addTotalsColumnToHeader } from './utils.table';

interface HeaderType {
  key: string;
  name: string;
  unit: string;
}
interface TableVignetteComponentProps {
  header: HeaderType[];
  data: Object[];
  headerCount?: number;
  background?: boolean;
  pdfTitle?: string;
  i18nInstance?: any;
}

export const TableVignetteComponent = ({
  header,
  data,
  headerCount = 2,
  background,
  pdfTitle,
  i18nInstance = null,
}: TableVignetteComponentProps) => {
  const { t: defaultT } = useTranslation();
  const t = i18nInstance ? i18nInstance.getFixedT() : defaultT;
  const dataWithTotals = addTotalsColumnToHeader(data[0], header);

  function createEmptyTableHeaders() {
    const emptyHeaders: JSX.Element[] = [];
    headerCount;
    if (headerCount) {
      for (let i = 0; i < headerCount; i++) {
        emptyHeaders.push(<th key={i} />);
      }
    }
    return emptyHeaders;
  }

  return (
    <>
      <h2>{t(pdfTitle)}</h2>
      <div className={background ? 'vignette' : ''} style={{ padding: 20 }}>
        <table className="table-vignette">
          <thead>
            <tr className="table-vignette__header">
              {createEmptyTableHeaders()}
              {header.map((headerItem) => (
                <th key={headerItem.key}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <span className="theader">{headerItem.name} </span>
                    <span style={{ fontWeight: 'lighter' }}>{headerItem.unit}</span>
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {dataWithTotals.map((row, index) => (
              <tr
                key={index}
                className={row.parent && 'table-vignette__body--parent'}
              >
                <td
                  className={
                    row.parent
                      ? 'table-vignette__body--parent'
                      : 'table-vignette__body'
                  }
                >
                  {row.name ?? ''}
                </td>
                <td className="table-vignette__body">{row?.zoneType ?? ''}</td>
                {header.map((header) => {
                  const stringifyNumber = () => {
                    let value = row.total ? row.total[header.key] : row[header.key];

                    const roundedValue = Math.round(value * 100) / 100;

                    return String(roundedValue);
                  };

                  return (
                    <td
                      key={header.key}
                      className="table-vignette__body table-vignette__body--align"
                    >
                      {stringifyNumber().replace('.', ',')}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};
